'use client';

import * as AccordionPrimitive from '@radix-ui/react-accordion';
import * as React from 'react';
import { Icon } from '@/components/entities/Sprite';
import { cn } from '@/utils/cn';

function BaseAccordion({
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Root>) {
  return <AccordionPrimitive.Root data-slot="accordion" {...props} />;
}

function BaseAccordionItem({
  className,
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Item>) {
  return (
    <AccordionPrimitive.Item
      data-slot="accordion-item"
      className={className}
      {...props}
    />
  );
}

function BaseAccordionTrigger({
  className,
  children,
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Trigger>) {
  return (
    <AccordionPrimitive.Header className="flex">
      <AccordionPrimitive.Trigger
        data-slot="accordion-trigger"
        className={cn(
          'focus-visible:border-ring focus-visible:ring-ring/50 flex flex-1 items-center justify-between gap-4 rounded-md text-left transition-all outline-none focus-visible:ring-[3px] disabled:pointer-events-none disabled:opacity-50 [&[data-state=closed]_.accordion-icon-open]:hidden [&[data-state=open]_.accordion-icon-closed]:hidden',
          className,
        )}
        {...props}
      >
        {children}
        <span className="accordion-icon-closed pointer-events-none flex size-6 shrink-0 items-center justify-center">
          <Icon
            name="plus"
            className="text-white size-4.5 transition-transform duration-200"
          />
        </span>
        <span className="accordion-icon-open pointer-events-none flex size-6 shrink-0 items-center justify-center">
          <Icon
            name="minus"
            className="text-white size-6 transition-transform duration-200"
          />
        </span>
      </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
  );
}

function BaseAccordionContent({
  className,
  children,
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Content>) {
  return (
    <AccordionPrimitive.Content
      data-slot="accordion-content"
      className="overflow-hidden text-sm data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
      {...props}
    >
      <div className={cn('pt-0 pb-4', className)}>{children}</div>
    </AccordionPrimitive.Content>
  );
}

export { BaseAccordion, BaseAccordionContent, BaseAccordionItem, BaseAccordionTrigger };
